import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-qa"]
const _hoisted_2 = { class: "_flexcol" }
const _hoisted_3 = ["href", "title"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_backer_center_thumbnail = _resolveComponent("backer-center-thumbnail")
  const _component_base_text = _resolveComponent("base-text")
  const _component_backer_center_header = _resolveComponent("backer-center-header")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass($options.itemClassList),
    "data-qa": `backer-center-payments-list-item:${$props.paymentID}`
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_backer_center_header, null, {
        prefix: _withCtx(() => [
          _createVNode(_component_backer_center_thumbnail, {
            url: $props.yourPledgeUrl,
            "image-url": $props.projectImageUrl,
            name: $props.name
          }, null, 8 /* PROPS */, ["url", "image-url", "name"])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_base_text, {
            as: "div",
            level: "b1",
            class: "_toe"
          }, {
            default: _withCtx(() => [
              _createElementVNode("a", {
                href: $props.yourPledgeUrl,
                title: $props.name
              }, _toDisplayString($props.name), 9 /* TEXT, PROPS */, _hoisted_3)
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_base_text, {
            as: "div",
            level: "caption",
            class: "_tc--light"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString($options.summary), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          })
        ]),
        suffix: _withCtx(() => [
          _createVNode(_component_base_text, {
            level: "b1",
            class: _normalizeClass($options.amountClasses),
            "data-qa": "backer-center-payments-list-item-data:Amount"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString($options.formattedAmount), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["class"])
        ]),
        _: 1 /* STABLE */
      })
    ])
  ], 10 /* CLASS, PROPS */, _hoisted_1))
}